import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

var PendingTag = function PendingTag() {
  return import('~/components/functional/TcVars/PendingTag.vue');
};

export default {
  name: 'AnnouncementBanner',
  components: {
    PendingTag: PendingTag
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8;

      return {
        color: ((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? _ref8.text_color : _ref8 : _ref8) || '',
        background: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.background_color : _ref7 : _ref7) || '',
        title: ((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? _ref6.title : _ref6 : _ref6) || '',
        url: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.url) != null ? _ref5.url : _ref5 : _ref5 : _ref5) || '',
        icon: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? (_ref4 = _ref4.icon) != null ? _ref4.url : _ref4 : _ref4 : _ref4) || '',
        tracking: {
          event_category: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.event_category : _ref3 : _ref3) || '',
          event_action: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.event_action : _ref2 : _ref2) || '',
          event_label: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.event_label : _ref : _ref) || ''
        }
      };
    },
    type: function type() {
      return this.currentPayload.url ? 'a' : 'span';
    },
    displayTracking: function displayTracking() {
      return {
        data: {
          event_category: this.currentPayload.tracking.event_category,
          event_action: 'Display_banner',
          event_label: this.currentPayload.tracking.event_label || this.currentPayload.title
        }
      };
    }
  },
  methods: {
    clickTracking: function clickTracking(evt) {
      this.$root.$emit('generic-tracking', evt, {
        data: {
          event_category: this.currentPayload.tracking.event_category,
          event_action: 'Click_banner',
          event_label: this.currentPayload.tracking.event_label || this.currentPayload.title
        }
      });
    }
  }
};